import ability from './ability'

export default [
  ability
]
